export default __webpack_public_path__ + "static/media/116.18ef8ae9.svg";